import { wrapFunc } from '../../util/js';

export const actUI = wrapFunc((dispatch, values) => {
  dispatch({
    type: 'UI_UPDATE',
    payload: values,
  });
});
